import dayjs from 'dayjs';

export const dateTimeFormat: Intl.DateTimeFormatOptions = {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
};

export const getDaysToExpiry = (date: Date): string => {
  const now = dayjs();
  const dateTime = date.toLocaleDateString('en-US', dateTimeFormat);
  const daysLeft = dayjs(date).diff(now, 'day');

  let expiryString: string = dateTime;

  switch (daysLeft) {
    case 0: {
      const hoursLeft = dayjs(date).diff(now, 'hour');

      switch (hoursLeft) {
        case 0: {
          const minutesLeft = dayjs(date).diff(now, 'minute');

          expiryString +=
            minutesLeft < 0
              ? ' (EXPIRED <1 hour ago)'
              : ' (expires in <1 hour)';

          break;
        }
        case 1: {
          expiryString += ' (expires in 1 hour)';

          break;
        }
        case -1: {
          expiryString += ' (EXPIRED 1 hour ago)';

          break;
        }
        default: {
          expiryString +=
            hoursLeft > 1
              ? ` (expires in ${hoursLeft} hours)`
              : ` (EXPIRED ${hoursLeft * -1} hours ago)`;
        }
      }

      break;
    }
    case 1: {
      expiryString += ' (expires in 1 day)';

      break;
    }
    case -1: {
      expiryString += ' (EXPIRED 1 day ago)';

      break;
    }
    default: {
      expiryString +=
        daysLeft > 1
          ? ` (expires in ${daysLeft} days)`
          : ` (EXPIRED ${daysLeft * -1} days ago)`;
    }
  }
  return expiryString;
};
